import styled from 'styled-components'

import {
  CheckMark,
  ResponsiveImage,
  ResponsiveImageWithSkeletonWrapper,
  TypeStyle,
  focusOutlineWithin,
  fromMd,
} from '@syconium/little-miss-figgy'

import { LayoutVariant } from '../../../../../../../TileLayout/types'

export const Image = styled(ResponsiveImageWithSkeletonWrapper)`
  object-fit: cover;
  width: 164px;
  height: 205px;
  box-sizing: border-box;
  &:hover {
    cursor: pointer;
  }
  margin: -4px 0;

  ${fromMd} {
    height: 280px;
    width: 224px;
  }
`

export const ImageDisabled = styled(ResponsiveImage)`
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  opacity: 0.5;
  -webkit-transition: none;
  &:hover {
    cursor: auto;
    border: ${o => o.theme.spacing(0.5)} solid inherit;
    transform: scale(1);
  }
  margin: -4px 0;
`

export const ImageWrapper = styled.div<{ $isChecked: boolean }>`
  overflow: hidden;
  border: ${o => o.theme.spacing(0.5)} solid
    ${o => (!o.$isChecked ? `transparent` : o.theme.color.deprecated.obsidian)};
  position: relative;
  border-radius: ${o => o.theme.spacing(2)};
  margin-left: auto;
  margin-right: auto;
`

export const Body = styled.figure<{ $isChecked: boolean; $layoutDesktop: LayoutVariant }>`
  ${Image} {
    border-radius: ${o => o.theme.spacing(2)};
  }

  width: 164px;

  ${fromMd} {
    width: 224px;
  }

  ${focusOutlineWithin};
`

export const FilterCtaText = styled.div<{
  isUppercase: boolean
  isChecked: boolean
  isDisabled: boolean
}>`
  ${TypeStyle.css.headlineExtraSmall}
  padding-top: ${o => o.theme.spacing(2)};
  padding-bottom: ${o => o.theme.spacing(1)};
  color: ${o =>
    o.isDisabled
      ? o.theme.color.deprecated.stoneDark
      : o.isChecked
      ? o.theme.color.deprecated.obsidian
      : o.theme.color.deprecated.obsidianLight};
  ${fromMd} {
    padding-top: ${o => o.theme.spacing(2)};
    padding-bottom: ${o => o.theme.spacing(2)};
  }
  &:hover {
    cursor: ${o => (o.isDisabled ? 'auto' : 'pointer')};
  }
`
export const FilterDescription = styled.div<{
  isUppercase: boolean
  isChecked: boolean
  isDisabled: boolean
}>`
  ${fromMd} {
    font-size: 12px;
  }
  font-size: 10px;
  font-weight: 500;
  letter-spacing: ${o => (o.isUppercase ? '0.15em' : '0.05em')};
  line-height: 20px;
  color: ${o =>
    o.isDisabled
      ? o.theme.color.deprecated.stoneDark
      : o.isChecked
      ? o.theme.color.deprecated.obsidianLighter
      : o.theme.color.deprecated.obsidianLighter};
  &:hover {
    cursor: ${o => (o.isDisabled ? 'auto' : 'pointer')};
  }
`

export const SelectIcon = styled(CheckMark)<{ $active: boolean }>`
  border-radius: ${o => o.theme.borderRadius.full};
  cursor: pointer;
  height: 24px;
  width: 24px;
  border: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.strong};
  background: ${o => (o.$active ? o.theme.color.fill.strong : o.theme.color.fill.background)};
  opacity: ${o => (o.$active ? 1 : 0.5)};
  position: absolute;
  padding: 5px;
  box-sizing: border-box;
  bottom: ${o => o.theme.spacing(2)};
  left: ${o => o.theme.spacing(2)};

  path {
    fill: ${o => (o.$active ? o.theme.color.fill.background : 'transparent')};
  }
`

export const BulletPoints = styled(TypeStyle.BodyNano)`
  gap: ${o => o.theme.spacing(2)};
  display: flex;
  flex-direction: column;
`

export const BulletPointRow = styled.div`
  display: flex;
  gap: ${o => o.theme.rowGap.tiny};
  color: ${o => o.theme.color.text.secondary.on.background};
`

export const BulletPointIcon = styled(ResponsiveImage)`
  height: 16px;
  width: 16px;
  /* ResponsiveImage overrides */
  overflow: visible;
  background: none;
`
